'use client'

import Grid from '@mui/material/Grid2';
import dynamic from 'next/dynamic';
import React, {useEffect} from 'react';
import Cookies from "js-cookie";
import {useSearchParams} from "next/navigation";
const PageContainer = dynamic(() => import('@/components/common/page-container'), { ssr: false });

export default function RootLayout({
    choose_advisor,
    session_details
}: Readonly<{
    choose_advisor: React.ReactNode;
    session_details: React.ReactNode;
}>) {

  const searchParams = useSearchParams();


    return (
        <PageContainer
            className='Consultation_Layout flex flex-col gap-8 lg:pt-8 pt-6'
        >

            <Grid
                sx={{ width: '100%' }}
                container
                spacing={'24px'}
            >
                <Grid
                    container
                    flex={1}
                    size={{ lg: 8, md: 12, sm: 12, xs: 12 }}
                    className={'Consultation_GridRight'}
                >
                    {choose_advisor}

                </Grid>
                <Grid
                    size={{ lg: 4, md: 12, sm: 12, xs: 12 }}
                    className={'Consultation_GridLeft'}
                >
                    <div className=' lg:sticky lg:top-3 '>
                        {session_details}
                    </div>
                </Grid>
            </Grid>

        </PageContainer>
    );
};
